import React, { useState } from 'react';

import { useApp } from '../modules/appModule';

import AppointmentsUnsetTable from '../components/folder-components/appointments/appointments--unsent-table';
import HomeNavigator from '../components/home-navigator';
import SearchBar from '../components/forms/search-bar';

/**
 * Home Component
 * This component renders a button that navigates the user to the intervention page when clicked.
 */
const Home = () => {
    const { version } = useApp();

    // State to manage the search modal visibility
    const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);

    return (
        <React.Fragment>
            <div className="home-page">

                <HomeNavigator
                    setIsSearchModalOpen={setIsSearchModalOpen}
                />

                <AppointmentsUnsetTable />

                { /* App information */ }
                <div className="app-info">
                    <strong>Informations sur l'application</strong>
                    <p>{`Version de l'application: ${version}`}</p>
                </div>
            </div>

            {/* Search modal */}
            <SearchBar
                open={isSearchModalOpen}
                onClose={() => setIsSearchModalOpen(false)}
            />
        </React.Fragment>
    );
};

export default Home;
